// File: /pages/About/E_Waste_Recycling.js
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Discuss from 'parts/Discuss';
import Button from 'elements/Button';

export default function EWasteRecycling() {
  return (
    <>

      <section className="hero py-12">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold text-theme-blue mb-4">E-Waste Recycling</h1>
          <p className="text-gray-600 max-w-3xl mx-auto">We responsibly recycle outdated hardware and help clients minimize environmental impact through certified disposal and refurbishment programs.</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 space-y-6">
          <div className="p-6 bg-white rounded-2xl shadow-md">
            <h3 className="text-xl font-semibold mb-2">What We Recycle</h3>
            <p className="text-gray-600">Computers, servers, networking gear, printers, batteries, and peripherals — following data sanitization best practices.</p>
          </div>

          <div className="p-6 bg-white rounded-2xl shadow-md">
            <h3 className="text-xl font-semibold mb-2">Our Process</h3>
            <ol className="list-decimal list-inside text-gray-600">
              <li>Assessment & data sanitization</li>
              <li>Component refurbishment where possible</li>
              <li>Responsible disposal of non-repairable materials</li>
              <li>Certificate of recycling provided</li>
            </ol>
          </div>

          <div className="text-center">
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full">Arrange Recycling Pickup</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
